import { ProblemDetails, ResponseContext } from "../../../@api";

import { translationKeys } from "../../models/app-translation-keys";
import { IMiddelware } from "../../models/interfaces/middelware.interface";
import { GlobalErrorsStore } from "../../stores";
import { getResponseBodyContent } from "./middlewareUtils";

export class ErrorResponseHandlingMiddleware implements IMiddelware {
  public readonly handledHttpStatusCodes = [200, 201, 202, 204];

  public readonly skipHttpStatusCodes = [400, 401, 403, 422, 429, 500, 503];

  constructor(private readonly globalErrorsStore: GlobalErrorsStore) {}

  public async post(context: ResponseContext): Promise<Response | void> {
    if (this.handledHttpStatusCodes.includes(context.response.status)) {
      // Success
      this.resetError();
    } else if (!this.skipHttpStatusCodes.includes(context.response.status)) {
      // Error
      this.setError(context);
    }
  }

  public resetError() {
    this.globalErrorsStore.removeError(translationKeys.globalErrors.serverConnection);
  }

  public async setError(context: ResponseContext) {
    this.globalErrorsStore.addErrorIfNotExists(translationKeys.globalErrors.serverConnection);
    const bodyContent = (await getResponseBodyContent(context)) as ProblemDetails;
    const message = bodyContent?.detail ?? bodyContent?.title ?? bodyContent?.type;
    alert(`Unexpected HTTP ${context.response.status} error:\n${message ?? "something happened!"}`);
  }
}
